import moment from 'moment';

export const getCategoryIdFromResourceId = (jobs, resouceId) => {
  let supcatIndex = null;
  let catIndex = null;
  let subCatIndex = null;
  let resouceIndex = null;

  if (jobs?.length > 0) {
    for (let sIndex = 0; sIndex < jobs.length; sIndex++) {
      const supCat = jobs[sIndex];
      if (supCat?.resources.length > 0) {
        resouceIndex = supCat.resources.findIndex((res) => res.id === resouceId);
        supcatIndex = sIndex;
        if (resouceIndex >= 0) return { supcatIndex, catIndex, subCatIndex, resouceIndex };
      }
      if (supCat?.categories?.length > 0) {
        for (let index = 0; index < supCat.categories.length; index++) {
          const category = supCat.categories[index];
          if (category?.resources?.length > 0) {
            resouceIndex = category.resources.findIndex((res) => res.id === resouceId);
            supcatIndex = sIndex;
            catIndex = index;
            if (resouceIndex >= 0) return { supcatIndex, catIndex, subCatIndex, resouceIndex };
          }
          if (category?.categories?.length > 0) {
            for (let cIndex = 0; cIndex < category.categories.length; cIndex++) {
              const subCat = category.categories[cIndex];
              if (subCat?.resources?.length > 0) {
                resouceIndex = subCat.resources.findIndex((res) => res.id === resouceId);
                supcatIndex = sIndex;
                catIndex = index;
                subCatIndex = cIndex;
                if (resouceIndex >= 0) return { supcatIndex, catIndex, subCatIndex, resouceIndex };
              }
            }
          }
        }
      }
    }
  };
  return { supcatIndex, catIndex, subCatIndex, resouceIndex };
};

export const getAllJobResourceIdAndDate = (jobs, weekDates) => {
  let data = [];
  if (jobs?.length > 0) {
    for (let sIndex = 0; sIndex < jobs.length; sIndex++) {
      const supCat = jobs[sIndex];
      if (supCat?.resources?.length > 0) {
        for (let index = 0; index < supCat.resources.length; index++) {
          const resource = supCat.resources[index];
          const jobsIds = weekDates.map(oneDay => {
            return {
              resourceId: resource?.id,
              jobDate: moment(oneDay).format('YYYY-MM-DD')
            };
          });
          data = [...data, ...jobsIds];
        }
      }
      if (supCat?.categories?.length > 0) {
        for (let index = 0; index < supCat.categories.length; index++) {
          const category = supCat.categories[index];
          if (category?.resources?.length > 0) {
            for (let index = 0; index < category.resources.length; index++) {
              const resource = category.resources[index];
              const jobsIds = weekDates.map(oneDay => {
                return {
                  resourceId: resource?.id,
                  jobDate: moment(oneDay).format('YYYY-MM-DD')
                };
              });
              data = [...data, ...jobsIds];
            }
          }
          if (category?.categories?.length > 0) {
            for (let cIndex = 0; cIndex < category.categories.length; cIndex++) {
              const subCat = category.categories[cIndex];
              if (subCat?.resources?.length > 0) {
                for (let index = 0; index < subCat.resources.length; index++) {
                  const resource = subCat.resources[index];
                  const jobsIds = weekDates.map(oneDay => {
                    return {
                      resourceId: resource?.id,
                      jobDate: moment(oneDay).format('YYYY-MM-DD')
                    };
                  });
                  data = [...data, ...jobsIds];
                }
              }
            }
          }
        }
      }
    }
  };
  return data;
};

export const getCategoryIdsFromResourceId = (jobs, newJobs) => {
  let resouceIndex = null;
  let indexArray = [];

  if (jobs?.length > 0 && newJobs?.length > 0) {
    for (let jobIndex = 0; jobIndex < newJobs.length; jobIndex++) {
      const newJob = newJobs[jobIndex];
      for (let sIndex = 0; sIndex < jobs.length; sIndex++) {
        const supCat = jobs[sIndex];
        if (supCat?.resources?.length > 0) {
          resouceIndex = supCat.resources.findIndex((res) => res.id === newJob.resourceId);
          if (resouceIndex >= 0) {
            indexArray = [...indexArray,
            { resouceIndex, supcatIndex: sIndex, catIndex: null, subCatIndex: null, jobId: newJob.id }];
            continue;
          }
        }
        if (supCat?.categories?.length > 0) {
          for (let index = 0; index < supCat.categories.length; index++) {
            const category = supCat.categories[index];
            if (category?.resources?.length > 0) {
              resouceIndex = category.resources.findIndex((res) => res.id === newJob.resourceId);
              if (resouceIndex >= 0) {
                indexArray = [...indexArray,
                { resouceIndex, supcatIndex: sIndex, catIndex: index, subCatIndex: null, jobId: newJob.id }];
                continue;
              }
            }
            if (category?.categories?.length > 0) {
              for (let cIndex = 0; cIndex < category.categories.length; cIndex++) {
                const subCat = category.categories[cIndex];
                if (subCat?.resources?.length > 0) {
                  resouceIndex = subCat.resources.findIndex((res) => res.id === newJob.resourceId);
                  if (resouceIndex >= 0) {
                    indexArray = [...indexArray, {
                      resouceIndex, supcatIndex: sIndex, catIndex: index, subCatIndex: cIndex, jobId: newJob.id
                    }];
                    continue;
                  };
                }
              }
            }
          }
        }
      }
    }
  };
  return indexArray;
};

export const updatedArrayFromCategoryIndex = (supcatIndex, catIndex, subCatIndex, resouceIndex, currentResourceJob, jobData) => {
  let newArray = null;
  if (subCatIndex !== null) {
    newArray = {
      [supcatIndex]: {
        categories: {
          [catIndex]: {
            categories: {
              [subCatIndex]: {
                resources: {
                  [resouceIndex]: {
                    jobs: { $set: [...currentResourceJob, ...jobData] }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else if (catIndex !== null) {
    newArray = {
      [supcatIndex]: {
        categories: {
          [catIndex]: {
            resources: {
              [resouceIndex]: {
                jobs: { $set: [...currentResourceJob, ...jobData] }
              }
            }
          }
        }
      }
    }
  } else {
    newArray = {
      [supcatIndex]: {
        resources: {
          [resouceIndex]: {
            jobs: { $set: [...currentResourceJob, ...jobData] }
          }
        }
      }
    }
  }
  return newArray;
};

export const getDeleteJobIndexData = (jobs, deletedJobId) => {
  let data = null;
  if (jobs?.length > 0) {
    for (let supIndex = 0; supIndex < jobs.length; supIndex++) {
      const supCat = jobs[supIndex];
      if (supCat?.resources?.length > 0) {
        for (let srIndex = 0; srIndex < supCat.resources.length; srIndex++) {
          const resource = supCat.resources[srIndex];
          if (resource.jobs.length > 0) {
            for (let sjIndex = 0; sjIndex < resource.jobs.length; sjIndex++) {
              const job = resource.jobs[sjIndex];
              if (job.id === deletedJobId) {
                data = {
                  supcatIndex: supIndex, catIndex: null, subCatIndex: null,
                  resouceIndex: srIndex, jobIndex: sjIndex
                };
              }
            }
          }
        }
      }
      if (supCat?.categories?.length > 0) {
        for (let index = 0; index < supCat.categories.length; index++) {
          const category = supCat.categories[index];
          if (category?.resources?.length > 0) {
            for (let rIndex = 0; rIndex < category.resources.length; rIndex++) {
              const resource = category.resources[rIndex];
              if (resource.jobs.length > 0) {
                for (let jIndex = 0; jIndex < resource.jobs.length; jIndex++) {
                  const job = resource.jobs[jIndex];
                  if (job.id === deletedJobId) {
                    data = {
                      supcatIndex: supIndex, catIndex: index, subCatIndex: null,
                      resouceIndex: rIndex, jobIndex: jIndex
                    };
                  }
                }
              }
            }
          }
          if (category?.categories?.length > 0) {
            for (let subIndex = 0; subIndex < category.categories.length; subIndex++) {
              const subCat = category.categories[subIndex];
              if (subCat?.resources?.length > 0) {
                for (let rIndex = 0; rIndex < subCat.resources.length; rIndex++) {
                  const resource = subCat.resources[rIndex];
                  if (resource.jobs.length > 0) {
                    for (let jIndex = 0; jIndex < resource.jobs.length; jIndex++) {
                      const job = resource.jobs[jIndex];
                      if (job.id === deletedJobId) {
                        data = {
                          supcatIndex: supIndex, catIndex: index, subCatIndex: subIndex,
                          resouceIndex: rIndex, jobIndex: jIndex
                        };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  return data;
};

export const jobsArrayAfterDeleteFromCategoryIndex = (supcatIndex, catIndex, subCatIndex, resouceIndex, jobIndex) => {
  let newArray = null;
  if (subCatIndex !== null) {
    newArray = {
      [supcatIndex]: {
        categories: {
          [catIndex]: {
            categories: {
              [subCatIndex]: {
                resources: {
                  [resouceIndex]: {
                    jobs: { $splice: [[jobIndex, 1]] }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else if (catIndex !== null) {
    newArray = {
      [supcatIndex]: {
        categories: {
          [catIndex]: {
            resources: {
              [resouceIndex]: {
                jobs: { $splice: [[jobIndex, 1]] }
              }
            }
          }
        }
      }
    }
  } else {
    newArray = {
      [supcatIndex]: {
        resources: {
          [resouceIndex]: {
            jobs: { $splice: [[jobIndex, 1]] }
          }
        }
      }
    }
  }
  return newArray;
};

export const getCurrentResouce = (listJobs, supcatIndex, catIndex, subCatIndex, resouceIndex) => {
  let currentResource = null;
  if (subCatIndex !== null) {
    currentResource = listJobs[supcatIndex]?.categories[catIndex]?.categories[subCatIndex]?.resources[resouceIndex]?.jobs;
  } else if (catIndex !== null) {
    currentResource = listJobs[supcatIndex]?.categories[catIndex]?.resources[resouceIndex]?.jobs;
  } else {
    currentResource = listJobs[supcatIndex]?.resources[resouceIndex]?.jobs;
  }
  return currentResource;
};